import { useQuery } from "@tanstack/react-query"
import { campaignQuery } from "../lib/campaignQuery"

export function useCampaignQuery(...args: Parameters<typeof campaignQuery>) {
  return useQuery(campaignQuery(...args))
}
